export default class Query {
  q: string = '';
  options: object = {};
  filters: object = {};
  sort: string = '';
  direction: 'asc' | 'desc' = 'asc';
  page: number = 1;
  per_page: number = null;
  results: any[] = [];
  inProgress: boolean = false;

  constructor(props: {per_page?, direction?} = {}, options: object = {}) {
    if (props.per_page) {
      this.per_page = props.per_page;
    }
    if (props.direction) {
      this.direction = props.direction;
    }
    this.options = options;
  }

  get isDown(): boolean {
    return this.direction === 'desc';
  }

  get isUp(): boolean {
    return this.direction === 'asc';
  }

  get hasResults(): boolean {
    return this.results.length > 0;
  }

  loadFromJson(json, options: any = {}): this {
    for (const keyName in json) {
      if (options.except) {
        if (options.except.includes(keyName)) {
          continue;
        }
      } else if (options.only) {
        if (!options.only.includes(keyName)) {
          continue;
        }
      }

      this[keyName] = json[keyName];
    }
    return this;
  }

  asJson(): any {
    return window.AppConfig.mergeJson({
      q: this.q,
      options: this.options,
      sort: this.sort,
      direction: this.direction,
      page: this.page,
      per_page: this.per_page,
    }, this.filters);
  }

  setQ(value: string = ''): void {
    this.q = value;
  }

  setSortAndDirection(newSort: string): void {
    this.setDirection(newSort);
    this.setSort(newSort);
  }

  setDirection(newSort: string): void {
    if (this.sort === newSort) {
      this.direction = this.direction === "asc" ? "desc" : "asc";
    } else {
      this.direction = "asc";
    }
  }

  setSort(value: string = ''): void {
    this.sort = value;
  }

  setPage(value: number = 1): void {
    this.page = value;
  }

  setFilters(filters: object = {}): void {
    this.filters = filters;
  }

  prepare(q: string): void {
    this.q = q;
    this.inProgress = true;
  }

  clearQ(): void {
    this.q = '';
  }

  clearResults(): void {
    this.results = [];
  }

  clear(): void {
    this.clearQ();
    this.clearResults();
  }

  reset(): void {
    this.clear();
    this.direction = 'asc';
    this.setSort();
    this.setPage();
  }

  sortIs(value: string): boolean {
    return this.sort === value;
  }
}
